import WaitingConfirmation from './WaitingConfirmation';

export default WaitingConfirmation;
